
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AreaSelect from "@/components/scope/area-select.vue";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";

@InjectFunction("dayjs", "appCode")
@Component({
  components: { AreaSelect }
})
export default class FilterBar extends Vue {
  @Prop({
    default: () => []
  })
  data: any[];
  @Prop({
    default: "monthStartToYesterday" // thatDay 初始化默认当天, monthStartToYesterday 月初到昨天   monthStartToday 月初到今天
  })
  initDateRang: any;
  selfData: any[] = [];
  currentTime: any = {
    year: "",
    month: "",
    day: ""
  };
  now: any = null;
  created() {
    // 获取前一天时间
    this.now = this.dayjs();
    this.currentTime.year = this.now.format("YYYY");
    this.currentTime.month = this.now.format("MM");
    this.currentTime.day = this.now.format("DD");

    this.selfData = this.data.slice();
    this.selfData.forEach(item => {
      if (item.type === "select-view") {
        if (!item.value) {
          item.value = item.selectList[0].value;
        }
        if (item.selectList.every(v => v.itemValue === "")) {
          this.resetTimeValue();
        }
      }
    });
    this.$emit("search", this.selfData);
  }
  changeTiemValue(value, isSameYear) {
    if (isSameYear) {
      if (value[0].slice(0, 4) !== value[1].slice(0, 4)) {
        this.$message.warning(t("v210901.the-time-range-must-same-year"));
        this.resetTimeValue();
      }
    }
  }
  // 默认选择当前时间范围
  resetTimeValue() {
    this.selfData.forEach(item => {
      if (item.type === "select-view") {
        item.selectList.forEach(part => {
          if (item.value === part.value) {
            if (part.itemValueFormat === "yyyyMMdd") {
              if (this.initDateRang === "monthStartToYesterday") {
                let yesterday;
                if (this.now.date() !== 1) {
                  yesterday = this.now.subtract(1, "d");
                } else {
                  yesterday = this.now;
                }
                part.itemValue = [yesterday.format("YYYYMM01"), yesterday.format("YYYYMMDD")];
              } else if (this.initDateRang === "monthStartToday") {
                part.itemValue = [this.now.format("YYYYMM01"), this.now.format("YYYYMMDD")];
              } else if (this.initDateRang === "thatDay") {
                const thatDayStr = this.dayjs().format("YYYYMMDD");
                part.itemValue = [thatDayStr, thatDayStr];
              }
            } else if (part.itemValueFormat === "yyyyMM") {
              part.itemValue = [this.now.format("YYYY01"), this.now.format("YYYYMM")];
            }
          }
        });
      }
    });
  }

  addZero(num) {
    return num < 10 ? "0" + num : String(num);
  }
  search() {
    this.$emit("search", this.selfData);
  }
  reset() {
    this.selfData.forEach(item => {
      if (item.type === "select-view") {
        item.selectList.forEach(part => {
          if (Object.prototype.toString.call(part.itemValue) === "[object Array]") {
            part.itemValue = [];
          } else {
            part.itemValue = "";
          }
        });
      } else {
        item.value = "";
        item.labels = "";
      }
    });
    this.resetTimeValue();
    this.$emit("reset", this.selfData);
  }
  // 切换选项卡 重置数据
  handleSelectChange(row) {
    this.selfData.forEach(item => {
      if (item.prop === row.prop) {
        item.selectList.forEach(part => {
          if (Object.prototype.toString.call(part.itemValue) === "[object Array]") {
            part.itemValue = [];
          } else {
            part.itemValue = "";
          }
          if (item.value === part.value) {
            if (part.itemValueFormat === "yyyyMMdd") {
              if (this.initDateRang === "monthStartToYesterday") {
                let yesterday;
                if (this.now.date() !== 1) {
                  yesterday = this.now.subtract(1, "d");
                } else {
                  yesterday = this.now;
                }
                part.itemValue = [yesterday.format("YYYYMM01"), yesterday.format("YYYYMMDD")];
              } else if (this.initDateRang === "monthStartToday") {
                part.itemValue = [this.now.format("YYYYMM01"), this.now.format("YYYYMMDD")];
              } else if (this.initDateRang === "thatDay") {
                const thatDayStr = this.dayjs().format("YYYYMMDD");
                part.itemValue = [thatDayStr, thatDayStr];
              }
            } else if (part.itemValueFormat === "yyyyMM") {
              part.itemValue = [this.now.format("YYYY01"), this.now.format("YYYYMM")];
            }
          }
        });
      }
    });
  }
  handleAreaChange(val, item) {
    this.$nextTick(() => {
      this.$nextTick(() => {
        const labels = (this.$refs["refAareSelect"] as any)[0].getLabels();
        item.labels = labels;
      });
    });
  }
  @Watch("data")
  watchData(val) {
    this.selfData.forEach((item, index) => {
      if (item.type === "select-search") {
        item.selectList = val[index].selectList;
      }
      if (item.type === "select-view") {
        item.selectList.forEach((v, i) => {
          v.itemSelectList = val[index].selectList[i].itemSelectList;
        });
      }
      if (item.type === "select") {
        item.selectList = val[index].selectList;
      }
    });
  }
}
